import React from 'react';
import {
  Box,
  Button,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Table,
  TableContainer,
  Tbody,
  Td,
  Tr
} from '@chakra-ui/react';
import { BiExpand } from 'react-icons/bi';

const ActiveDevice = ({ appPlatform, activeDeviceDetails }) => {
  return (
    <Popover>
      <PopoverTrigger>
        <Button
          variant={'link'}
          color={'white'}
          fontWeight={400}
          padding={0}
          textDecoration={'underline'}
          rightIcon={<BiExpand />}
        >
          {' '}
          {appPlatform}
        </Button>
      </PopoverTrigger>
      <PopoverContent
        bg="altGray.200"
        color="white"
        border={0}
        width="unset"
        maxWidth="100vw"
      >
        <PopoverArrow bg="altGray.200" boxShadow={'none !important'} />
        <PopoverCloseButton />
        <PopoverBody p={3} pb={1}>
          <Box pt={4}>
            <TableContainer
              alignSelf={{
                base: 'flex-start',
                lg: 'center'
              }}
            >
              <Table variant="simple" maxWidth={'100%'}>
                <Tbody maxWidth={'100%'}>
                  {activeDeviceDetails.map((item) => (
                    <Tr key={item.name} maxWidth={'100%'} fontSize={'sm'}>
                      <Td
                        color={'shadedGray.300'}
                        pt="0"
                        pl={'0'}
                        pr={0}
                        border="none"
                        maxWidth={'20rem'}
                        whiteSpace={'break-word'}
                        pb={'0.75rem'}
                      >
                        {item.name}:
                      </Td>
                      <Td color={'white'} pt="0" border="none" pb={'0.75rem'}>
                        {item.value}
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default ActiveDevice;
